import { createFeatureSelector, createSelector } from '@ngrx/store';

import { IState as ILiveState, liveFeatureKey } from '../reducers/index';
import { IState, adapter } from '../reducers/live-segments.reducer';

// Feature selector
const selectLiveState = createFeatureSelector<ILiveState>(liveFeatureKey);

// Segments state selector
export const selectSegmentsState = createSelector(selectLiveState, (state: ILiveState) => state.segments);

// Get the selectors for the entity adapter
const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors(selectSegmentsState);

// Export the entity selectors
export const selectSegmentIds = selectIds;
export const selectSegmentEntities = selectEntities;
export const selectAllSegments = selectAll;
export const selectSegmentTotal = selectTotal;

// Individual property selectors
export const selectSegmentsLoaded = createSelector(selectSegmentsState, (state: IState) => state.loaded);
export const selectSegmentsSearchContext = createSelector(selectSegmentsState, (state: IState) => state.searchContext);

export const selectSegmentsLoading = createSelector(selectSegmentsState, (state: IState) => state.isLoading);

export const selectSegmentsError = createSelector(selectSegmentsState, (state: IState) => state.error);
